export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "token.worker.dce7a02db9a6b6bf5ab8.worker.js");
}
